<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "استمارة القروض - الجريح",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "استمارة القروض - الجريح",
          href: "/pankLoans/injouies",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      injury: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("pankLoansInjury", ["getInjury"]),
  },
  methods: {
    ...mapActions("pankLoansInjury", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.injury = this.getInjury;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.injury.qr_id,
            fullName: this.injury.personal_info.full_name,
            date: this.injury.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">بيانات الجريح الشخصية</h5></div>
            <div class="row about-list">
              <h4>{{ injury.personal_info.full_name }}</h4>
              <div class="col-md-4">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ injury.personal_info.family_name }}</p>
                </div>
                <div class="media">
                  <label>اسم الام الثلاثي :</label>
                  <p>{{ injury.personal_info.mother_name }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ injury.personal_info.birth_date }}</p>
                </div>
                <div class="media">
                  <label>الحالة الاجتماعية :</label>
                  <p>{{ injury.personal_info.marital_status.title }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>عدد الابناء :</label>
                  <p>{{ injury.number_children }}</p>
                </div>
                <div class="media">
                  <label>التحصيل الدراسي :</label>
                  <p>{{ injury.personal_info.certificate.title }}</p>
                </div>
                <div class="media">
                  <label>الديانة :</label>
                  <p>{{ injury.affiliation.religion.title }}</p>
                </div>
                <div class="media">
                  <label>القومية :</label>
                  <p>{{ injury.affiliation.nationalism.title }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>رقم الهاتف 1 :</label>
                  <p>{{ injury.personal_info.phone1 }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف 2 :</label>
                  <p>{{ injury.personal_info.phone2 }}</p>
                </div>
                <div class="media">
                  <label>رقم البطاقة الوطنية :</label>
                  <p>{{ injury.personal_info.nationality_number }}</p>
                </div>
                <div class="media">
                  <label>هوية الاحول المدنية :</label>
                  <p>{{ injury.personal_info.national_id_number }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات الاصابة</h5></div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>تاريخ الاصابة :</label>
                  <p>{{ injury.wounded_info.date_wound }}</p>
                </div>
                <div class="media">
                  <label>محل الحادث :</label>
                  <p>{{ injury.wounded_info.place_wound }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>التشكيل :</label>
                  <p>{{ injury.wounded_info.dept }}</p>
                </div>
                <div class="media">
                  <label>مكان الاصابة بالجسم :</label>
                  <p>{{ injury.wounded_info.place_wound_in_body }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>نسبة العجز :</label>
                  <p>{{ injury.wounded_info.disability_ratio }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">بيانات السكن</h5></div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>نوع السكن :</label>
                  <p>{{ injury.address.accommodation.title }}</p>
                </div>
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ injury.address.city.title }}</p>
                </div>
                <div class="media">
                  <label>المنطقة :</label>
                  <p>{{ injury.address.region }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>اقرب نقطة دالة :</label>
                  <p>{{ injury.address.nearest_point }}</p>
                </div>
                <div class="media">
                  <label>المحلة :</label>
                  <p>{{ injury.address.mahla }}</p>
                </div>
                <div class="media">
                  <label>الزقاق :</label>
                  <p>{{ injury.address.zqaq }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>الدار :</label>
                  <p>{{ injury.address.dar }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات القرض</h5></div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>نوع المصرف :</label>
                  <p>{{ injury.loan.bank_type.title }}</p>
                </div>
                <div class="media">
                  <label>اسم المصرف :</label>
                  <p>{{ injury.loan.grant_name }}</p>
                </div>
                <div class="media">
                  <label>اسم مستلم القرض :</label>
                  <p>{{ injury.loan.borrower_name }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>مبلغ القرض :</label>
                  <p>{{ injury.loan.amount }}</p>
                </div>
                <div class="media">
                  <label>المبلغ المسدد :</label>
                  <p>{{ injury.loan.amount_paid }}</p>
                </div>
                <div class="media">
                  <label>المبلغ المتبقي :</label>
                  <p>{{ injury.loan.amount_remaining }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>تاريخ استلام القرض :</label>
                  <p>{{ injury.loan.received_date }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">تنزيل المرفقات</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <a :href="injury.attachment.url_basic" target="_blank">
                  <b-button
                    :disabled="!injury.attachment.url_basic"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >المرفقات الثبوتية</b-button
                  >
                </a>

                <a :href="injury.attachment.url_info" target="_blank">
                  <b-button
                    :disabled="!injury.attachment.url_info"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق تأييد بالاصابة</b-button
                  >
                </a>

                <a :href="injury.attachment.url_loan" target="_blank">
                  <b-button
                    :disabled="!injury.attachment.url_loan"
                    variant="primary"
                    type="button"
                    class="me-2"
                    >مرفق الكشف المصرفي</b-button
                  >
                </a>
              </div>
            </div>

            <QrCodeCard
              title="استمارة اطفاء القروض الحكومية"
              :fullName="this.injury.personal_info.full_name"
              :date="this.injury.created_at"
              :Id="this.injury.qr_id"
              :qrCodeContent="this.qrCodeContent"
            ></QrCodeCard>

            <div class="mt-3">
              <hr />
              <!-- <b-button variant="primary" type="button" class="me-2">
                <i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</b-button
              > -->
              <b-button
                class=""
                type="button"
                to="/pankLoans/injouies"
                variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
